<div class="container-fluid">
    <app-loader></app-loader>
    <app-page-title title="Ana Sayfa"></app-page-title>

    <!-- Modern tema: Operasyon Özeti blokları (klasik temada render edilmez).
         Her blok kullanıcının widget tercihine bağlı. 
    <app-modern-overview *ngIf="isModernTheme"
                         [showProfitKpi]="dailyProfitKpi?.selected"
                         [showEcommerceKpi]="ecommerceKpi?.selected"
                         [showLiveMarket]="liveMarket?.selected"
                         [showQuickActions]="quickActions?.selected">
    </app-modern-overview>
    -->
    <div class="row">
        <div class="col-md-12 col-12 table-responsive" style="overflow: hidden;">
            <ul class="nav nav-tabs mb-3" *ngIf="hasUserRole">
                <li class="nav-item">
                    <button type="button" class="nav-link" [ngClass]="{ 'active': selectedBalanceTab === 'branch' }"
                        (click)="selectBalanceTab('branch')">
                        Şube Bakiyesi
                    </button>
                </li>
                <li class="nav-item" *ngIf="hasMultiBranchAccess">
                    <button type="button" class="nav-link" [ngClass]="{ 'active': selectedBalanceTab === 'all' }"
                        (click)="selectBalanceTab('all')">
                        Genel Bakiye
                    </button>
                </li>
            </ul>

            <app-branch-balance *ngIf="selectedBalanceTab === 'branch'"></app-branch-balance>
            <app-all-branches-balance *ngIf="selectedBalanceTab === 'all' && hasMultiBranchAccess"></app-all-branches-balance>

            <!-- Altın / sarrafiye stoku — sekmeyle aynı kapsamda (şube ya da tüm şubeler). -->
            <app-stock-balance *ngIf="selectedBalanceTab === 'branch'" scope="branch"></app-stock-balance>
            <app-stock-balance *ngIf="selectedBalanceTab === 'all' && hasMultiBranchAccess" scope="all"></app-stock-balance>
            <div class="d-flex justify-content-end mb-3" *ngIf="hasUserRole">
                <button triggers="hover" ngbTooltip="Görünümü Özelleştir" (click)="openWidgetCustomizerModal()"
                    container="body" class="btn btn-sm btn-primary"><i class="far fa-window-restore"></i></button>
            </div>
            <div class="row" *ngIf="hasUserRole">
                <ng-container *ngIf="customerBalance?.selected">
                    <div class="col-12">
                        <app-customer-balance-report></app-customer-balance-report>
                    </div>
                </ng-container>
                <ng-container *ngIf="manufactureOrders?.selected">
                    <div class="col-md-6">
                        <app-manufacture-orders-tab-widget></app-manufacture-orders-tab-widget>
                    </div>
                </ng-container>
                <ng-container *ngIf="agreedList?.selected">
                    <div class="col-md-6">
                        <app-exchange-list-mini [filter]="agreedFilter" title="Alım/Satım Bağlantı Listesi"></app-exchange-list-mini>
                    </div>
                </ng-container>
                <ng-container *ngIf="incomeBarChart?.selected">
                    <div class="col-md-6">
                        <app-expense-income-chart [isIncome]="true"></app-expense-income-chart>
                    </div>
                </ng-container>
                <ng-container *ngIf="expenseBarChart?.selected">
                    <div class="col-md-6">
                        <app-expense-income-chart [isIncome]="false"></app-expense-income-chart>
                    </div>
                </ng-container>
                <ng-container *ngIf="hasAssetsPieChart?.selected">
                    <div class="col-md-6">
                        <app-branch-balance-pie-chart></app-branch-balance-pie-chart>
                    </div>
                </ng-container>
                <ng-container *ngIf="hasAssetsNegativeBarChart?.selected">
                    <div class="col-md-6" >
                        <app-negative-bar-chart></app-negative-bar-chart>
                    </div>
                </ng-container>
                <ng-container *ngIf="debtList?.selected">
                    <div class="col-md-6">
                        <app-customer-debt-receivable-list [isDebtList]="true"></app-customer-debt-receivable-list>
                    </div>
                </ng-container>
                <ng-container *ngIf="receivableList?.selected">
                    <div class="col-md-6">
                        <app-customer-debt-receivable-list [isDebtList]="false"></app-customer-debt-receivable-list>
                    </div>
                </ng-container>
            </div>
        </div>
    </div>
</div>
